import { useDeviceType } from '@cian/ui-kit';
import { LazyImage } from '../LazyImage';
import { UTP } from './constants';
import * as styles from './styles.css';
import { clsx } from 'clsx';

export const AdRanking: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['title']}>Ранжирование объявлений</div>
      <div className={styles['list']}>
        {UTP.map(item => (
          <div className={styles['item']} key={item.title}>
            <div className={styles['item-title']}>{item.title}</div>
            <LazyImage
              src={item.image}
              alt={item.title}
              className={styles['image']}
              wrapperClassName={styles['image-wrapper']}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
